:host {
  block-size: 100%;
}

$sharedPadding: 16px;

.welcome-container {
  --opacity: 1;
  --translate-y: 0;
  opacity: var(--opacity);
  transform: translateY(var(--translate-y));
  transition: all var(--transition-duration);
  display: flex;
  block-size: 100%;
  grid-template-rows: max-content max-content;
  flex-direction: column;
  justify-content: space-between;
  background-repeat: no-repeat;
  background-size: cover;
  background-size: contain;

  &.hidden {
    --opacity: 0;
    --translate-y: 4px;
  }
}

%absolute-centered {
  position: absolute;
  inset-inline-start: 50%;
  inset-block-start: 50%;
  transform: translate(-50%, -50%);
}

.header {
  --opacity: 0;
  --translate-y: 3px;
  transition: all var(--transition-duration) var(--transition-delay)
    cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateY(var(--translate-y));
  opacity: var(--opacity);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xl);
  align-items: center;
  padding: $sharedPadding;

  &--visible {
    --opacity: 1;
    --translate-y: 0;
  }

  &__circle {
    $circleSize: 55px;
    inline-size: $circleSize;
    block-size: $circleSize;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-block-end: calc(8px * -1);
  }

  &__title {
    display: grid;
    text-align: center;
    margin: 0;
    text-align: center;
    white-space: pre-line;
    line-height: var(--line-height-regular);
    font-weight: var(--font-style-semi-bold);
    font-size: var(--font-size-header-h3);
  }

  &__greeting {
    line-height: var(--line-height-relaxed);
    text-align: center;
    font-weight: var(--font-style-regular);
  }
}

.suggested-prompts {
  --opacity: 1;
  opacity: var(--opacity);
  transition: opacity var(--transition-duration);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-xl);
  list-style: none;
  margin: 0;
  padding: $sharedPadding;

  &.hidden {
    --opacity: 0;
  }

  &__button {
    // TODO: This buttons are the "suggestion buttons", currently not supported on Mercury.
    // Remove this styles once they are supported/provided by Mercury.

    opacity: 0;
    transform: translateX(-3px);
    animation: fadeInSuggestedPromptButton var(--timing-regular) ease forwards;
    animation-delay: var(--delay, 0s);
    padding: var(--spacing-padding-l);
    border-radius: 44px;
    font-style: oblique;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: var(--spacing-gap-m);
    max-inline-size: 300px;

    background-color: var(--color-component-button-suggestion-accent-default);
    color: var(--color-text-neutral-default);
    border: 1px solid
      var(--color-component-button-suggestion-border-default);

    &:hover {
      background-color: var(--color-component-button-suggestion-accent-hover);
      border-color: var(--color-component-button-suggestion-border-hover);
      color: var(--color-text-primary-hover);
    }

    &:active {
      background-color: var(--color-component-button-suggestion-accent-pressed);
      border-color: var(--color-component-button-suggestion-border-pressed);
      color: var(--color-text-neutral-pressed);
    }
  }

  &__icon {
    flex-shrink: 0;
  }
}

@keyframes fadeInSuggestedPromptButton {
  from {
    opacity: 0;
    transform: translateX(-3px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
